export function setupEmailLinks(): void {
    const emailLinks = document.querySelectorAll<HTMLAnchorElement>('[href^=mailto]');

    emailLinks.forEach((link) => {
        const emailVal = link.getAttribute('href')?.split('mailto:')[1] ?? '';
        link.setAttribute('aria-label', `Email ${emailVal}`);
    });
}
